import { Button, type ButtonProps } from '@energiebespaarders/symbols/components/Button';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useActiveHouseProgress } from '~/hooks/useActiveHouseProgress';
import type { SpacingProps } from '@energiebespaarders/symbols/lib/hoc/withSpacing';

const NavActionButton: React.FC<ButtonProps & SpacingProps> = ({ ...buttonProps }) => {
  const { data } = useActiveHouseProgress();
  const { asPath } = useRouter();

  const actionButtonProps = useMemo(() => {
    buttonProps.bgColor = 'yellow';
    buttonProps.color = 'grayBlack';
    buttonProps.mb = 0;
    buttonProps.mr = 0;
    buttonProps.px = 3;

    const defaultProps = { to: '/intake', label: 'Start Woningscan', ...buttonProps };
    if (!data) return defaultProps;

    const { house, customerIntakeByHouse } = data;

    if (house.quoteRequests.length) {
      if (asPath.includes('/intake/indicaties')) {
        buttonProps.hidden = true;
      }
      return {
        to: '/intake/indicaties',
        label: 'Bekijk je mogelijkheden',
        ...buttonProps,
      };
    }

    if (house.sentQuotes.filter(q => !q.isAccepted).length) {
      if (asPath.includes('/mijn-offertes')) {
        buttonProps.hidden = true;
      }
      return { to: '/mijn-offertes', label: 'Bekijk offertes', ...buttonProps };
    }

    if (house.advice.isSent) {
      if (asPath.includes('/mijn-energiepaspoort')) {
        buttonProps.hidden = true;
      }
      return { to: '/mijn-energiepaspoort', label: 'Bekijk advies', ...buttonProps };
    }

    if (house.intake.isPlanned && !house.intake.isStarted) {
      if (asPath.includes('/mijn-afspraken')) {
        buttonProps.hidden = true;
      }
      return { to: '/mijn-afspraken', label: 'Bekijk afspraken', ...buttonProps };
    }

    if (customerIntakeByHouse?.submittedOn) {
      if (asPath.includes('/intake/indicaties')) {
        buttonProps.hidden = true;
      }
      return { to: '/intake/indicaties', label: 'Bekijk je mogelijkheden', ...buttonProps };
    }

    return defaultProps;
  }, [data, buttonProps, asPath]);

  return actionButtonProps.hidden ? (
    <></>
  ) : (
    <Button
      data-testid="nav-cta"
      style={{
        whiteSpace: 'nowrap',
        borderRadius: 3,
      }}
      {...actionButtonProps}
    />
  );
};

export default NavActionButton;
